/*
 * 接口统一集成模块
 */
import * as login from './moudules/login';
import * as menu from './moudules/menu';
import * as role from './moudules/role';
import * as department from './moudules/department';
import * as employee from './moudules/employee';
import * as user from './moudules/user';
import * as editlog from './moudules/editlog';
import * as otherUrl from './moudules/otherUrl';
import * as excel from './moudules/excel';
import * as report from './moudules/report';
import * as Material from './moudules/Material';
import * as position from './moudules/position';
import * as dictionary from './moudules/dictionary';
import * as bankCard from './moudules/bankCard';
import * as staff from './moudules/staff';
import * as certificate from './moudules/certificate';
import * as family from './moudules/family';
import * as education from './moudules/education';
import * as organization from './moudules/Organization';
import * as Region from './moudules/Region';
import * as Customer from './moudules/Customer';
import * as priceBook from './moudules/priceBook';
import * as OrderPurchase from './moudules/OrderPurchase';
import * as Car from './moudules/Car';
import * as SysLogApi from './moudules/SysLogApi';
import * as StkInProductApi from './moudules/stk/StkInProductApi';
import * as StkInProductEntryApi from './moudules/stk/StkInProductEntryApi';
import * as StkInProductReturnApi from './moudules/stk/StkInProductReturnApi';
import * as StkInProductReturnEntryApi from './moudules/stk/StkInProductReturnEntryApi';
import * as StkInAllocation from './moudules/stk/StkInAllocation';
import * as Sales from './moudules/Sales';
import * as Warehous from './moudules/Warehous';
import * as Recharge from './moudules/Recharge';
import * as BaseSchoolingExp from './moudules/BaseSchoolingExp';
import * as RebateStrategy from './moudules/RebateStrategy';
import * as CarryFor from './moudules/CarryFor';
import * as Invoicing from './moudules/Invoicing';
import * as wx from './moudules/wx';
import * as MaterialIssueDoc from './moudules/stk/MaterialIssueDoc';
import * as MaterialReturnNote from './moudules/stk/MaterialReturnNote';
import * as OtherReturu from './moudules/stk/OtherReturu';
import * as BaseMaterialQualityApi from './moudules/BaseMaterialQualityApi';
import * as BaseMaterialStockApi from './moudules/BaseMaterialStockApi';
import * as QcMaterialQualityi from './moudules/QcMaterialQualityi';
// 默认全部导出
export default {
  login,
  menu,
  role,
  department,
  employee,
  user,
  editlog,
  otherUrl,//地磅称重
  excel,
  report,
  position,//职位
  Material,//商品（物料）
  dictionary,//字典
  bankCard, // 员工银行卡
  staff, // 员工管理
  certificate, // 证件
  family, // 家庭情况
  education, // 教育经历
  organization,//组织
  Region,//区域
  Customer,//往来单位（客户）
  priceBook,//价格本（基础）
  OrderPurchase,//采购订单（包装物）
  Car,//车
  SysLogApi,//日志
  StkInProductApi,//产成品入库单
  StkInProductEntryApi,//产成品入库单明细
  StkInProductReturnApi,//产成品退货单
  StkInProductReturnEntryApi,//产成品退货单明细
  Sales,//销售
  Warehous,//仓库（其它入库）
  Recharge,//充值
  BaseSchoolingExp,//学历
  RebateStrategy,//返利策略
  CarryFor,//单位结转
  Invoicing,//开票
  wx,//微信公告
  StkInAllocation,//仓库调拨
  MaterialIssueDoc,//材料出库单
  MaterialReturnNote,//材料退货单
  OtherReturu,//其他出库单
  BaseMaterialQualityApi,//物料质量标准
  BaseMaterialStockApi,//物料仓库配置
  QcMaterialQualityi,//材料质检单
}



// WEBPACK FOOTER //
// ./src/api/api.js